export * from "./badge.directive";
export * from "./badge.module";
